import FamilyCalendar from '../components/Calendar';

const CalendarPage = () => (
  <div>
    <FamilyCalendar />
  </div>
);

export default CalendarPage;
